import React from "react";
import { Box } from "@mui/material";
import { ShareActionProvider } from "../contexts/ShareActionContext";
import HousingForecast from "../components/tools/HousingForecast";

const SharedHousingForecastToolPage: React.FC = () => {
  return (
    <ShareActionProvider>
      <Box sx={{ maxWidth: 1100, mx: "auto", p: { xs: 2, sm: 3 } }}>
        <HousingForecast />
      </Box>
    </ShareActionProvider>
  );
};

export default SharedHousingForecastToolPage;
